import * as React from 'react'
import styled from 'styled-components'

const StyledCaret = styled.svg`
  transition: transform ease-in-out 0.15s;
  display: flex;
  justify-content: center;
  align-items: center;

  &.up {
    transform: rotate(-90deg);
  }

  &.left {
    transform: rotate(180deg);
  }

  &.down {
    transform: rotate(90deg);
  }
`

export default function CaretDown({ direction = 'right', size = 16 }) {
  const width = size
  const height = (8 / 9) * size

  return (
    <StyledCaret
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      className={direction}
      xmlns="http://www.w3.org/2000/svg"
    >
      <line
        x1="1.25167"
        y1="-1.25167"
        x2="8.64353"
        y2="-1.25167"
        transform="matrix(0.707413 -0.706801 0.707413 0.706801 4.5 15)"
        stroke="#323F4B"
        strokeWidth="2.50334"
        strokeLinecap="round"
      />
      <line
        x1="1.25167"
        y1="-1.25167"
        x2="8.64353"
        y2="-1.25167"
        transform="matrix(-0.707413 -0.706801 0.707413 -0.706801 11.5 7.99396)"
        stroke="#323F4B"
        strokeWidth="2.50334"
        strokeLinecap="round"
      />
    </StyledCaret>
  )
}
